import { TListedPlaylist } from '../types/responses/video';

export const hasPlayCourseStructure = (playlist: TListedPlaylist): boolean =>
  Boolean(
    playlist.courseStructure?.nodes?.length ||
      playlist.courseStructure?.sourcePlaylistIds?.length
  );

export const isPlayCourseDraft = (playlist: TListedPlaylist): boolean =>
  Boolean(
    playlist.isCourse &&
      !playlist.items?.length &&
      !playlist.videos?.length &&
      !hasPlayCourseStructure(playlist)
  );

export const isPlayCourseContainer = (playlist: TListedPlaylist): boolean =>
  Boolean(playlist.isCourse);

export const isFlatPlaylistEntry = (playlist: TListedPlaylist): boolean =>
  !playlist.isCourse;
